import { render, staticRenderFns } from "./loginSSO.vue?vue&type=template&id=83cbb73e&scoped=true&"
import script from "./loginSSO.vue?vue&type=script&lang=js&"
export * from "./loginSSO.vue?vue&type=script&lang=js&"
import style0 from "./loginSSO.vue?vue&type=style&index=0&id=83cbb73e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cbb73e",
  null
  
)

export default component.exports